export class NoAccessTokenReceivedError extends Error {
    constructor() {
        super('No access token received');
    }
}
